import { auth, authProvider } from "../firebase";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import "../css/styles.css";
import { createUserIfNotExists } from "./createUser";

export const Auth = (setIsAuthenticated: (arg: boolean) => void) => {
  const signInWithGoogle = async () => {
    signInWithPopup(auth, authProvider)
    .then(async (result) => {
      const credential = GoogleAuthProvider.credentialFromResult(result);
      if (!credential) {
        throw new Error("No credential returned from Google Sign-In");
      }
      await createUserIfNotExists(result.user);
      setIsAuthenticated(true);
    })
  };

  return (
    <div className="login-page">
      <p>Sign In With Google Because I'm Lazy Thanks</p>
      <button className="login-with-google-btn" onClick={signInWithGoogle}>
        {" "}
        Sign In With Google
      </button>
    </div>
  );
};
